
export default {
    name: "",
    parameters: "",
}
